import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import Teblemission from "./teblemission";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");
export default function mission({ navigation, route }) {
  const item = route.params.item;
  console.log(item);
  const focus = useIsFocused();
  const [data, setdata] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);

  async function getallusermission() {
    const response = await apiservice({
      path: "/admin/getallBymission?mission_id=" + item.id,
      method: "get",
      token: token?.accessToken,
    });
    console.log(response);
    if (response.status == 200) {
      setdata(response.data.data);
    }
  }
  useEffect(() => {
    getallusermission();
  }, [token, focus]);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />

          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              EVENT{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ภารกิจ </Text>
              </Text>
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>{item.titel}</Text>
              </Text>
            </Text>
          </View>
          <Teblemission data={data} />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
});
